<template>
    <div>
      <div class="d-flex align-center" v-if="!create_order_page">
        <div class="category-name"><p>{{ category_name }}</p></div>
        <span @click="categoryChange = !categoryChange" class="cursor-pointer ml-2 small-icon-button" v-if="update_allowed"><editicon class="svg-18"></editicon></span>
      </div>

        <div class="row justify-content-center p-4" v-show="categoryChange || create_order_page">
            <div class="entry-selection-item align-self-start col-12 col-md-5 row">

              <input type="hidden" v-model="categoryIdSelected" name="categoryId" id="content_submission" class="form-control content_submission">

              <div class="category-select-wrap col-12" v-for="category in categories">
                <span class="radio-custom cursor-pointer mr-1 d-flex" @click="categoryClicked(category.id)">
                  <circle_filled v-if="categoryIdSelected == category.id" class="svg-black svg-24 mr-3"></circle_filled>
                  <circle_empty v-else class="svg-black svg-24 mr-3"></circle_empty>
                  <span>{{ category.name }}</span>
                </span>
              </div>
            </div>

            <div class="entry-selection-item align-self-start col-12 col-md-7">
              <div class="entry-description-wrapper p-4" v-show="categorySelected">
                  <div class="entry-description" v-show="categoryIdSelected == category.id"  v-for="category in categories">
                    <h2> {{ category.name }}</h2>
                    <p v-html="category.description"></p>
                  </div>
                </div>
            </div>
          <div class="col-12" v-if="!create_order_page">
            <span class="btn btn-primary" @click="saveCategoryAndRefresh()">Update Category</span>
            <span class="btn btn-black" @click="categoryChange = false">Cancel</span>
          </div>
        </div>

        <div class="col-12 d-flex--no-override justify-content-between align-items-center mt-4" v-if="create_order_page">
            <a href="/" class="btn btn-black h-100 btn-wide btn-accent-text f-16">Cancel</a>
            <button @click.prevent="checkRequired()" class="btn btn-primary btn-wide btn-black-text f-16" type="submit" :disabled="!categorySelected">
                <div>
                    <span class="submit-text">Next</span>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
  import circle_filled from "../components/icons/circle_filled.vue";
  import circle_empty from "../components/icons/circle.vue";

  export default {
    components: {circle_empty, circle_filled},
      props: ['categories', 'create_order_page', 'category_id_from_order', 'action_url', 'category_name_from_order', 'update_allowed'],
      data() {
          return {
              categorySelected: false,
              categoryIdSelected: this.category_id_from_order ? this.category_id_from_order : '-1',
              categoryChange: false,
              category_name: this.category_name_from_order ? this.category_name_from_order : ''
          }
      },
      methods: {
        categoryClicked: function(catId) {
              var that = this;
              that.categoryIdSelected = catId;
              that.categorySelected = true;
          },
        saveCategoryAndRefresh: function() {
          let app = this;
          window.axios(
              {
                method: 'post',
                url: app.action_url,
                data: {
                  category_id: app.categoryIdSelected
                }
              }).then(function (response) {
            location.reload();
          });
        },
        checkRequired() {
          let that = this;
          if($('#create-order-form #entry_title').val() != '') {
            $('#create-order-form').submit();
          } else {
            $('#entry_title').addClass('required');
            that.$scrollTo('#top-of-form', 700);
          }
        }
      }
  }
</script>
